import { cn } from "@/lib/utils"

interface ProgressBarLoaderProps {
  className?: string
}

function ProgressBarLoader(props: ProgressBarLoaderProps) {
  return (
    <div className={cn("progress-bar", props.className)} aria-hidden="true" role="progressbar">
      <div className="first-indicator" id="console-splash-progress-021280" style={{ transform: "scaleX(0.8)" }}>
        <span className="first-indicator-inner"></span>
      </div>
    </div>
  )
}

interface ProgressBarTop {
  className?: string
  barClassName?: string
  size?: "lg" | "md"
}

export function ProgressBarTop(props: ProgressBarTop) {
  return (
    <div className={cn("absolute left-0 top-0 w-full", props.className)}>
      <ProgressBarLoader
        className={cn(
          "z-20 !my-0 !py-0",
          props.size === "lg" &&
            `
              !h-[5px]

              [&_.first-indicator-inner]:!border-t-[5px]
            `,
          props.barClassName,
        )}
      />
    </div>
  )
}

export default ProgressBarLoader
